import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { Grid, Header } from 'semantic-ui-react';
import PxGrid from 'components/layout/PxGrid';
import { CollectiveBillPriceInfo, PatientInfo } from 'components/billing/collective-bill/CollectiveBillView';
import EmptyDataMessage from 'components/layout/EmptyDataMessage';
import { numberFormatter } from 'utils/fomattingUtils';

interface Props extends MessageSourceProps {
  collectiveBillPriceInfo?: CollectiveBillPriceInfo,
}

class CollectiveBillView extends Component<Props> {


  render(): React.ReactElement {
    const {collectiveBillPriceInfo, getMessage} = this.props;
    return (
        <PxGrid>
          <Grid.Row>
            <Grid.Column width={16}>
              <Header>{getMessage("bill.information")}</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign={"middle"}>
              {getMessage("bill.amount")}:
            </Grid.Column>
            <Grid.Column width={13} verticalAlign={"middle"}>
              {collectiveBillPriceInfo && numberFormatter.format(collectiveBillPriceInfo.amount)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign={"middle"}>
              {getMessage("collectiveBill.discount")}:
            </Grid.Column>
            <Grid.Column width={13} verticalAlign={"middle"}>
              {collectiveBillPriceInfo && numberFormatter.format(collectiveBillPriceInfo.discount)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign={"middle"}>
              {getMessage("collectiveBill.AHV")}:
            </Grid.Column>
            <Grid.Column width={13} verticalAlign={"middle"}>
              {collectiveBillPriceInfo && numberFormatter.format(collectiveBillPriceInfo.ahv)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign={"middle"}>
              {getMessage("collectiveBill.ALV")}:
            </Grid.Column>
            <Grid.Column width={13} verticalAlign={"middle"}>
              {collectiveBillPriceInfo && numberFormatter.format(collectiveBillPriceInfo.alv)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign={"middle"}>
              {getMessage("collectiveBill.total")}:
            </Grid.Column>
            <Grid.Column width={13} verticalAlign={"middle"}>
              {collectiveBillPriceInfo && numberFormatter.format(collectiveBillPriceInfo.total)}
            </Grid.Column>
          </Grid.Row>
        </PxGrid>
    );
  };

}

export default withMessages(CollectiveBillView);
